import React from 'react';
import { TextArea } from '../../../textfield';
import { jsonStringify } from '../../../../../util/formatters';

const  JSONValueEditor = React.memo(({ value, disabled, onChange }) => {
	const handleChange = event => {
		const incoming = event.target.value;
		try {
			const json = JSON.parse(incoming);
			onChange(json);
		} catch(jsonError) { //supress 
		}
		
    };

	return <TextArea onChange={handleChange} rowsMin={5} disabled={disabled} defaultValue={jsonStringify(value)} />
});

export default JSONValueEditor;